import Vue from 'vue';
import Vuex from 'vuex';

import LogRocket from 'logrocket';
import createPlugin from 'logrocket-vuex';

const logrocketPlugin = createPlugin(LogRocket);

import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

import bills from './modules/bills';
import twoFactor from './modules/twoFactor';
import identity from './modules/identity';
import refund from './modules/refund';
import transaction from './modules/transaction';
import streamerWidgets from './modules/streamer/widgets';
import cards from './modules/cards';
import reports from './modules/reports';
import timezone from './modules/timezone';
import project from './modules/project';
import partnership from './modules/partnership';
import ticket from './modules/ticket';
import wallet from './modules/wallet';

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    bills,
    twoFactor,
    identity,
    refund,
    transaction,
    streamerWidgets,
    cards,
    reports,
    timezone,
    project,
    partnership,
    ticket,
    wallet,
  },
  plugins: [logrocketPlugin],
});
